import { Category } from '@fcom/dapi/api/models';

export type BookingSummaryAncillaryKey =
  | 'purchase.payment.seatCount'
  | 'purchase.payment.baggageCount'
  | 'purchase.payment.mealCount'
  | 'purchase.payment.wifiCount'
  | 'purchase.payment.loungeCount'
  | 'purchase.payment.coverCount'
  | 'purchase.payment.sportCount'
  | 'purchase.payment.petCount'
  | 'purchase.payment.cabinBaggageCount';

export interface ServiceMapping {
  category: Category;
  icon: string;
  bookingSummaryKey: BookingSummaryAncillaryKey;
}

export const serviceMapping: ServiceMapping[] = [
  {
    category: Category.CABIN_BAGGAGE,
    icon: 'carry-on-bag',
    bookingSummaryKey: 'purchase.payment.cabinBaggageCount',
  },
  {
    category: Category.BAGGAGE,
    icon: 'checked-in-baggage',
    bookingSummaryKey: 'purchase.payment.baggageCount',
  },
  {
    category: Category.MEAL,
    icon: 'food',
    bookingSummaryKey: 'purchase.payment.mealCount',
  },
  {
    category: Category.SEAT,
    icon: 'seat-or-economy',
    bookingSummaryKey: 'purchase.payment.seatCount',
  },
  {
    category: Category.WIFI,
    icon: 'wifi',
    bookingSummaryKey: 'purchase.payment.wifiCount',
  },
  {
    category: Category.LOUNGE,
    icon: 'lounge',
    bookingSummaryKey: 'purchase.payment.loungeCount',
  },
  {
    category: Category.SPORT,
    icon: 'bike',
    bookingSummaryKey: 'purchase.payment.sportCount',
  },
  {
    category: Category.PET,
    icon: 'pet',
    bookingSummaryKey: 'purchase.payment.petCount',
  },
  {
    category: Category.COVER,
    icon: 'insurance',
    bookingSummaryKey: 'purchase.payment.coverCount',
  },
];
